<template>
  <el-dialog
      v-model="dialogVisible"
      :title="formData.ID?'编辑选题类型':'新增选题类型'"
      width="400px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose">
    <div class="dialog-item1">
      <el-form :model="formData"
               label-width="auto"
               :rules="rules"
               class="el-form-box" ref="ruleFormRef">
        <el-row :gutter="10">
          <el-col :span="24" >
            <el-form-item label="名称：" prop="Name">
              <el-input v-model.trim="formData.Name" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="描述：" prop="Description" >
              <el-input v-model.trim="formData.Description" maxlength="300" rows="5" show-word-limit  type="textarea" placeholder="请输入"/>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="顺序：" prop="SortOrder" >
<!--              <el-input type="text" v-model="formData.CardId" />-->
              <el-input-number v-model="formData.SortOrder" :step="1" step-strictly/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="状态：" prop="Status" >
              <el-switch
                  v-model="formData.Status"
                  class="ml-2"
                  inline-prompt
                  style="--el-switch-on-color: #3f9dfd; --el-switch-off-color: #a9aaab"
                  active-text="启用"
                  inactive-text="不启用"
              />
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="save(ruleFormRef)"
                   :loading = "loading"
        >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, reactive,onMounted} from 'vue';
import {ElMessage} from "element-plus";
import {validateForm} from "@/utils/formValidate";
import {addMember, updateMember} from "@/api/student";
import {SEXS,STUDENTTYPE,GRADE,RANKSTUDENTLIMITED} from "@/utils/commonSetting"
import {addTopic, updateTopic} from "@/api/topicAdmin";
const emits = defineEmits(['close', 'success'])
const dialogVisible = ref(true)
const ruleFormRef = ref()

var formData = reactive({
  ID:null,
  Name: null, // 名称
  Description:null,// 描述
  SortOrder:null, // 排序
  Status:true,// 是否启用
})
const loading = ref(false)
const rules = ({
  Name: [{required: true, message: '请输入名称', trigger: ['change', 'blur']}],
  Description: [{required: true, message: '请输入描述', trigger: ['change', 'blur']}],
  SortOrder: [{required: true, message: '请设置排序', trigger: ['change', 'blur']}],
})

const props = defineProps({
  item: {
    default: {},
  },
  numbers:{
    default:5
  }
})
// 开始
onMounted(()=>{
  if(props.item && props.item.ID){
    formData.ID = props.item.ID
    formData.Name = props.item.Name
    formData.Description = props.item.Description
    formData.SortOrder = props.item.SortOrder
    formData.Status = props.item.Status===1
  }
})

const handleClose = () => {
  dialogVisible.value = false
  emits("close", true)
}
// 保存
const save = async (ruleFormRef) => {
  const isvalidate =await validateForm(ruleFormRef)
  if(!isvalidate){
    return
  }
  loading.value = true
  let res,messPre;
  const params = {
    ...formData,
    Status:formData.Status?1:2
  }
  if( formData.ID){
    res = await updateTopic(params)
    messPre = '修改'
  }else{
    res = await addTopic(params)
    messPre = '创建'
  }
  loading.value = false
  if(res.success){
    ElMessage.success(messPre + "成功")
    emits("success", true)
  }else{
    ElMessage.warning(res.err_msg || messPre + "失败")
  }

}
</script>

<style scoped>
.dialog-item1 {
  width: 100%;
  min-height: 340px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
